// libs
import React from 'react';

import { getUseFilterValues } from '@/components/FilterNew/utils/getUseFilterValues';
import { getUseOptionsQuery } from '@/components/FilterNew/utils/getUseOptionsQuery';
import BaseEntityFilter from '@/components/Filters/EntityFilter/BaseEntityFilter';

import { StaticFilterProps } from './types';

// check for bottom sheet override @iamsaumya
function StaticFilter({
  filterId,
  filter,
  setFilter,
  groups,
  defaultPlaceholder,
  pillProps,
  open,
  onToggle,
  children,
  operators,
  selectedOperator,
  listVariant = 'multi-ungrouped-finite',
}: StaticFilterProps) {
  const useOptionsQuery = getUseOptionsQuery(groups);
  const useFilterValues = getUseFilterValues({
    filter,
    filterId,
    groups,
  });

  return (
    <BaseEntityFilter
      defaultPlaceholder={defaultPlaceholder}
      filter={filter}
      id={filterId}
      initialSelectedOperator={selectedOperator}
      listConfig={{
        listVariant,
        useFilterValues,
        useOptionsQuery,
      }}
      open={open}
      operators={operators}
      pillProps={pillProps}
      setFilter={setFilter}
      uiConfig={{}}
      onToggle={onToggle}>
      {children}
    </BaseEntityFilter>
  );
}

export default StaticFilter;
